import { render, staticRenderFns } from "./host_limit.vue?vue&type=template&id=09158cc2&scoped=true&lang=pug&"
import script from "./host_limit.vue?vue&type=script&lang=js&"
export * from "./host_limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09158cc2",
  null
  
)

export default component.exports